// extracted by mini-css-extract-plugin
export default {"root":"root--PG_Fa","rootIsDark":"rootIsDark--WOWvh","heading":"heading--ejCMq","message":"message--R7IRD"};